export const RETRY_CONFIG = {
  maxRetries: 3,
  baseDelayMs: 1000,
  maxDelayMs: 10000,
} as const

export const PAGINATION = {
  defaultPageSize: 30,
} as const

export const UNREAD_QUERY_HARD_CAP = 500
